<script>import Button from "../Button.svelte";
import { attrValue } from "../../../../utils/html";
import SVG from "../../SVG.svelte";
import ProgressIndicator from "../../ProgressIndicator.svelte";
export let props = {};
const { label, ...rest } = props;
</script>

<Button
	props={{
		...rest,
		classNames: attrValue([props.classNames, 'flex gap-4 items-center'])
	}}
	on:click
>
	<span>{label}</span>
	{#if props.fetching}
		<ProgressIndicator size="small" />
	{:else}
		<SVG
			name="arrow_right"
			classNames={attrValue([props.iconClassNames, 'rounded-full p-1 flex-shrink-0'])}
		/>
	{/if}
</Button>
